export const GET_DEFENSES = "GET_DEFENSES"
export const GET_DEFENSES_FAIL = "GET_DEFENSES_FAIL"
export const GET_DEFENSES_SUCCESS = "GET_DEFENSES_SUCCESS"

export const ADD_NEW_DEFENSE = "ADD_NEW_DEFENSE"
export const ADD_DEFENSE_SUCCESS = "ADD_DEFENSE_SUCCESS"
export const ADD_DEFENSE_FAIL = "ADD_DEFENSE_FAIL"

export const UPDATE_DEFENSE = "UPDATE_DEFENSE"
export const UPDATE_DEFENSE_SUCCESS = "UPDATE_DEFENSE_SUCCESS"
export const UPDATE_DEFENSE_FAIL = "UPDATE_DEFENSE_FAIL"

export const DELETE_DEFENSE = "DELETE_DEFENSE"
export const DELETE_DEFENSE_SUCCESS = "DELETE_DEFENSE_SUCCESS"
export const DELETE_DEFENSE_FAIL = "DELETE_DEFENSE_FAIL"





